import { z } from 'zod';

export const dynaDocsModelSchema = z.object({
  description: z.string().min(1, 'La description ne doit pas être vide').max(500, 'La description ne doit pas dépasser 500 caractères'),
});
